/**
 * 紧凑视图 - 事务状态列定义
 * 包含许可、燃油、简报、配餐、接送、酒店等事务状态列
 */

import React from "react";
import { Tooltip } from "antd";
import { TRANSACTION_TYPES } from "../../../constants";
import TransactionCell from "../../TransactionCell";

/**
 * 获取事务状态列定义
 * @param {Object} options - 配置选项
 * @param {Object} options.user - 当前用户
 * @param {Function} options.refreshAndHighlightFlight - 刷新并高亮航班回调
 * @returns {Array} 列定义数组
 */
export const getTransactionColumns = ({ user, refreshAndHighlightFlight }) => {
    // 检查用户权限
    const hasTransactionPermission = user && (user.is_superuser || user.permissions?.includes("flight_operation:read") || user.permissions?.includes("flight_operation:create") || user.permissions?.includes("flight_operation:update") || user.permissions?.includes("flight_operation:delete"));

    if (!hasTransactionPermission) {
        return [];
    }

    return [
        {
            title: <Tooltip title="许可申请状态">许</Tooltip>,
            key: "permit_request",
            width: 28,
            align: "center",
            className: "compact-col-center",
            render: (_, record) => <TransactionCell flightId={record.id} transactionType={TRANSACTION_TYPES.PERMIT_REQUEST} flight={record} onSuccess={refreshAndHighlightFlight} compact={true} />,
        },
        {
            title: <Tooltip title="燃油申请状态">油</Tooltip>,
            key: "fuel_request",
            width: 28,
            align: "center",
            className: "compact-col-center",
            render: (_, record) => <TransactionCell flightId={record.id} transactionType={TRANSACTION_TYPES.FUEL_REQUEST} flight={record} onSuccess={refreshAndHighlightFlight} compact={true} />,
        },
        {
            title: <Tooltip title="飞行简报状态">简</Tooltip>,
            key: "flight_brief",
            width: 28,
            align: "center",
            className: "compact-col-center",
            render: (_, record) => <TransactionCell flightId={record.id} transactionType={TRANSACTION_TYPES.FLIGHT_BRIEF} flight={record} onSuccess={refreshAndHighlightFlight} compact={true} />,
        },
        {
            title: <Tooltip title="配餐订单状态">餐</Tooltip>,
            key: "catering_order",
            width: 28,
            align: "center",
            className: "compact-col-center",
            render: (_, record) => <TransactionCell flightId={record.id} transactionType={TRANSACTION_TYPES.CATERING_ORDER} flight={record} onSuccess={refreshAndHighlightFlight} compact={true} />,
        },
        {
            title: <Tooltip title="机组接送状态">接</Tooltip>,
            key: "crew_transportation",
            width: 28,
            align: "center",
            className: "compact-col-center",
            render: (_, record) => <TransactionCell flightId={record.id} transactionType={TRANSACTION_TYPES.CREW_TRANSPORTATION} flight={record} onSuccess={refreshAndHighlightFlight} compact={true} />,
        },
        {
            title: <Tooltip title="酒店住宿状态">宿</Tooltip>,
            key: "hotac",
            width: 28,
            align: "center",
            className: "compact-col-center",
            render: (_, record) => <TransactionCell flightId={record.id} transactionType={TRANSACTION_TYPES.HOTAC} flight={record} onSuccess={refreshAndHighlightFlight} compact={true} />,
        },
    ];
};

export default getTransactionColumns;
